module.exports = __webpack_public_path__ + "img/btc_bg@3x.c731ab58.png";